import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

const btn = "rounded-none uppercase tracking-wider text-xs";

// Generated founder note waits here until the admin publishes it to /about.
export default function FounderVoiceDraft({ draft, onPublished, onDiscarded }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!draft?.available) return undefined;
    let url;
    api.get("/admin/founder-voice/draft/audio", { responseType: "blob" }).then((r) => {
      url = URL.createObjectURL(r.data);
      setSrc(url);
    }).catch(() => toast.error("Couldn't load the draft audio."));
    return () => url && URL.revokeObjectURL(url);
  }, [draft?.available, draft?.updated_at]);

  if (!draft?.available) return null;

  const publish = async () => {
    try {
      onPublished((await api.post("/admin/founder-voice/publish")).data);
      toast.success("Published — the note is live on /about.");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't publish.");
    }
  };
  const discard = async () => {
    try {
      await api.delete("/admin/founder-voice/draft");
      onDiscarded();
    } catch {
      toast.error("Couldn't discard the draft.");
    }
  };

  return (
    <div className="mb-6 border border-terracotta/50 bg-terracotta/[0.06] p-4" data-testid="founder-voice-draft">
      <p className="font-sans text-xs uppercase tracking-[0.22em] text-terracotta mb-3">Draft · not on /about yet</p>
      {src && <audio controls src={src} className="max-w-full mb-3" data-testid="founder-voice-draft-audio" />}
      <div className="flex gap-3 flex-wrap">
        <Button onClick={publish} data-testid="founder-voice-publish" className={`${btn} bg-terracotta hover:bg-terracotta-deep text-obsidian-900`}>
          <Check className="h-4 w-4 mr-2" /> Publish to /about
        </Button>
        <Button onClick={discard} data-testid="founder-voice-discard" className={`${btn} bg-transparent border border-obsidian-600 text-bone-400 hover:text-terracotta hover:bg-transparent`}>
          <Trash2 className="h-4 w-4 mr-2" /> Discard
        </Button>
      </div>
    </div>
  );
}
